/* eslint-disable */

// import React from 'react';
// import ReactDOM from 'react-dom';
// import { BrowserRouter } from 'react-router-dom';
// import App from '../components/App.jsx';

// export default {
//   init() {
//     // JavaScript to be fired on the events page
//   },
//   finalize() {
//     // JavaScript to be fired on the events page, after the init JS
//     ReactDOM.render((
//       <BrowserRouter>
//         <App />
//       </BrowserRouter>
//     ), document.getElementById('root'));
//   },
// };



// WEBPACK FOOTER //
// ./scripts/routes/events.js